/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import Text from '@deprecated-ui/common/Text';
import Input from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import {
  ModalFooterContainer,
  ModalContainer,
  ModalTitle,
  Button,
  Modal,
} from './styled';

interface ISaveModalProps {
  isVisible: boolean;
  isOverrideMode?: boolean;
  isDeleteMode?: boolean;
  modalTitle: string;
  cancelText: string;
  onClickCancel: () => void;
  okText: string;
  onClickOk: (valuationName?: string) => void;
  initValuationName?: string;
}

const SaveModal = ({
  isVisible,
  isOverrideMode,
  isDeleteMode,
  modalTitle,
  cancelText,
  onClickCancel,
  okText,
  onClickOk,
  initValuationName,
}: ISaveModalProps) => {
  const [valuationName, setValuationName] = useState<string>('');

  useEffect(() => {
    setValuationName(initValuationName || '');
  }, [initValuationName]);

  const onTypeValuationName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setValuationName(value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onClickOk(valuationName.trim());
  };

  const ModalFooter = (
    <ModalFooterContainer>
      {/* @ts-expect-error */}
      <Button type="borderless" pl="0px" pr="0px" height="35px">
        <Text color={color.dimgray} onClick={() => onClickCancel()}>
          {cancelText}
        </Text>
      </Button>
      {/* @ts-expect-error */}
      <Button type="primary" pl="0px" pr="0px" height="35px">
        <Text
          color="inherit"
          onClick={() => {
            onClickOk(valuationName.trim());
          }}
        >
          {okText}
        </Text>
      </Button>
    </ModalFooterContainer>
  );

  return (
    <Modal
      destroyOnClose
      visible={isVisible}
      title={<ModalTitle>{modalTitle}</ModalTitle>}
      footer={ModalFooter}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      onCancel={onClickCancel}
      centered
    >
      <ModalContainer>
        {isOverrideMode ? (
          `Do you want to overwrite "${initValuationName}" valuation?`
        ) : isDeleteMode ? (
          `Are you sure you want to delete "${initValuationName}" valuation?`
        ) : (
          <form onSubmit={handleSubmit}>
            {/* @ts-expect-error */}
            <Text mb="8px">Valuation Name</Text>
            <Input
              autoFocus
              height="32px"
              width="100%"
              placeholder="Valuation Name"
              value={valuationName}
              onChange={onTypeValuationName}
            />
            <input type="submit" style={{ display: 'none' }} />
          </form>
        )}
      </ModalContainer>
    </Modal>
  );
};

SaveModal.defaultProps = {
  initValuationName: '',
  isOverrideMode: false,
  isDeleteMode: false,
};

export default SaveModal;
